import React from 'react';
import { getGoogleCategory } from 'api/google';
import { TGoogleCategory } from 'types/google';

let globalData: TGoogleCategory[] = [];

const useGoogleCategory = (): [TGoogleCategory[], boolean, () => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<TGoogleCategory[]>(globalData);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await getGoogleCategory();
            if (!result.error) {
                const data: TGoogleCategory[] = result?.data?.data || [];
                data.sort((a, b) => {
                    if (a.primary) {
                        return -1;
                    }
                    if (b.primary) {
                        return 1;
                    }
                    return 0;
                });
                globalData = data;
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (loading.current) {
            return;
        }
        fetchData();
    }, []);

    return [items, loading.current, fetchData];
};

export default useGoogleCategory;
